import React from "react";

const CenterTitle = ({ title, description }) => {
  return (
    <div className="center-title">
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
  );
};

export default CenterTitle;
